module.exports = __webpack_public_path__ + "images/emoji/imp.f4a07a80fceafa1e41e9.png";